import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const BetaTagWrapper = styled(Box)<{ isactive?: string }>`
  display: flex;
  padding: ${theme.spacing.half}px ${theme.spacing.xSmall}px;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xSmall}px;
  align-self: stretch;
  border-radius: 6px;
  background: ${({ isactive }) => (isactive && isactive === 'true' ? theme.colors.cta : theme.colors.betaChipInactive)};
  width: 44px;
  height: 22px;

  color: ${theme.colors.surfaceContainerBackground};
  text-align: center;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.medium};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.extraThick};
  line-height: 20px;
  letter-spacing: 0.1px;
`
